<ng-container [ngSwitch]="true">
  <ng-container *ngSwitchCase="currentPath.includes('service-weekly')">
    <mat-form-field appearance="fill" class="service-filter">
      <mat-label>Filter Techs by Zone</mat-label>
      <mat-select
        [(value)]="selectedZone"
        (selectionChange)="selectZone($event)"
      >
        <mat-option [value]="0">All Zones</mat-option>
        <mat-option [value]="zone.zoneId" *ngFor="let zone of zones">{{
          zone.zoneName
        }}</mat-option>
      </mat-select>
    </mat-form-field>
  </ng-container>

  <ng-container *ngSwitchCase="currentPath.includes('service-monthly')">
    <mat-form-field appearance="fill" class="service-filter">
      <mat-label>Filter Techs by Zone</mat-label>
      <mat-select
        (selectionChange)="getServiceTechsByZone($event.value)"
        [(value)]="selectedZone"
      >
        <mat-option [value]="0">All Zones</mat-option>
        <mat-option [value]="zone.zoneId" *ngFor="let zone of zones">{{
          zone.zoneName
        }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" class="service-filter">
      <mat-label>Select Service Tech</mat-label>
      <mat-select
        [(value)]="selectedTech"
        (selectionChange)="selectTech($event)"
      >
        <mat-option *ngFor="let tech of techArray" [value]="tech">{{
          tech.name
        }}</mat-option>
      </mat-select>
    </mat-form-field>
  </ng-container>
</ng-container>
